export default __webpack_public_path__ + "static/media/gacha.ee60e84b.png";